import { combineReducers } from 'redux';
import payments from './payments';
import stores from './stores';
import users from './users';
import locations from './locations';

import suppliers from './suppliers';
import taxSettings from './taxSettings';
import paymentTerms from './paymentTerms';
import paymentMethods from './paymentMethods';
import categories from './categories';
import products from './products';
import assignments from './assignments';
import purchaseOrders from './purchaseOrders';
import incompleteOrders from './incompleteOrders';
import purchaseOrderLines from './purchaseOrderLines';
import receivingOrders from './receivingOrders';
import settings from './settings';
import thresholds from './thresholds';
import suggestedPurchaseOrders from './suggestedPurchaseOrders';

export default combineReducers({
  payments,
  stores,
  users,
  incompleteOrders,
  locations,
  suppliers,
  taxSettings,
  paymentTerms,
  paymentMethods,
  categories,
  products,
  assignments,
  purchaseOrders,
  purchaseOrderLines,
  receivingOrders,
  settings,
  thresholds,
  suggestedPurchaseOrders,
});